var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 2.5H2.5V7.08333H8.33333V2.5Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 2.5C1.875 2.15482 2.15482 1.875 2.5 1.875H8.33333C8.67851 1.875 8.95833 2.15482 8.95833 2.5V7.08333C8.95833 7.42851 8.67851 7.70833 8.33333 7.70833H2.5C2.15482 7.70833 1.875 7.42851 1.875 7.08333V2.5ZM3.125 3.125V6.45833H7.70833V3.125H3.125Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.9167H11.6667V17.5H17.5V12.9167Z",
    fill: "#343434"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0417 12.9167C11.0417 12.5715 11.3215 12.2917 11.6667 12.2917H17.5C17.8452 12.2917 18.125 12.5715 18.125 12.9167V17.5C18.125 17.8452 17.8452 18.125 17.5 18.125H11.6667C11.3215 18.125 11.0417 17.8452 11.0417 17.5V12.9167ZM12.2917 13.5417V16.875H16.875V13.5417H12.2917Z",
    fill: "#343434"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5H11.6667V9.58333H17.5V2.5Z",
    fill: "#343434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0417 2.5C11.0417 2.15482 11.3215 1.875 11.6667 1.875H17.5C17.8452 1.875 18.125 2.15482 18.125 2.5V9.58333C18.125 9.92851 17.8452 10.2083 17.5 10.2083H11.6667C11.3215 10.2083 11.0417 9.92851 11.0417 9.58333V2.5ZM12.2917 3.125V8.95833H16.875V3.125H12.2917Z",
    fill: "#343434"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 10.4167H2.5V17.5H8.33333V10.4167Z",
    fill: "#343434"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 10.4167C1.875 10.0715 2.15482 9.79166 2.5 9.79166H8.33333C8.67851 9.79166 8.95833 10.0715 8.95833 10.4167V17.5C8.95833 17.8452 8.67851 18.125 8.33333 18.125H2.5C2.15482 18.125 1.875 17.8452 1.875 17.5V10.4167ZM3.125 11.0417V16.875H7.70833V11.0417H3.125Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4b8e3f6c73c3e3aa91bb427b85f8f310.svg";
export { ForwardRef as ReactComponent };